/* Award Winning landing page — carousels, tabs, mobile select. Vanilla JS, no dependencies. */
(function () {
  function initCarousel(root) {
    if (root._awInit) return;
    root._awInit = true;
    var track = root.querySelector('[data-aw-track]');
    var prev = root.querySelector('[data-aw-prev]');
    var next = root.querySelector('[data-aw-next]');
    if (!track || !prev || !next) return;
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= max;
    }
    function step(dir) {
      track.scrollBy({ left: dir * track.clientWidth * 0.85, behavior: 'smooth' });
    }
    prev.addEventListener('click', function () { step(-1); });
    next.addEventListener('click', function () { step(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    root._awUpdate = update;
    update();
  }

  function initTabs(root) {
    if (root._awInit) return;
    root._awInit = true;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-aw-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-aw-panel]'));
    var select = root.querySelector('[data-aw-select]');
    if (!tabs.length) return;

    function show(id, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-panel') === id;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        if (on && focus) t.focus();
      });
      panels.forEach(function (p) {
        var on = p.id === id;
        p.hidden = !on;
        if (on) {
          p.querySelectorAll('[data-aw-carousel]').forEach(function (c) { if (c._awUpdate) c._awUpdate(); });
        }
      });
      if (select) select.value = id;
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { show(tab.getAttribute('data-panel')); });
      tab.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
        if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
        if (n) { e.preventDefault(); show(n.getAttribute('data-panel'), true); }
      });
    });
    if (select) select.addEventListener('change', function () { show(select.value); });
    show(tabs[0].getAttribute('data-panel'));
  }

  function init() {
    document.querySelectorAll('[data-aw-carousel]').forEach(initCarousel);
    document.querySelectorAll('[data-aw-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
